import xsalsa20 from '../xsalsa20';

if (new Uint16Array([1])[0] !== 1)
  throw new Error('Big endian architecture is not supported.');

export const crypto_stream = function (c, nonce, key) {
  c.fill(0);
  crypto_stream_xor(c, c, nonce, key);
};

export const crypto_stream_xor = function (c, m, nonce, key) {
  const xor = xsalsa20(nonce, key);

  xor.update(m, c);
  xor.final();
};
